import * as TranslationKeys from "./translationKeys";

import en_common from "./locales/en/common.json";
import en_incomingInvoice from "./locales/en/incomingInvoice.json";
import en_missingDocument from "./locales/en/missingDocument.json";
import en_login from "./locales/en/login.json";
import en_receipt from "./locales/en/receipt.json";
import en_validations from "./locales/en/validations.json";
import en_errors from "./locales/en/errors.json";
import en_currency from "./locales/en/currency.json";
import en_invoice from "./locales/en/invoice.json";
import en_supportIssue from "./locales/en/supportIssue.json";
import en_survey from "./locales/en/survey.json";
import en_salaryDeviation from "./locales/en/salaryDeviation.json";
import en_country from "./locales/en/country.json";
import en_language from "./locales/en/language.json";
import en_company from "./locales/en/company.json";
import en_commissionSalary from "./locales/en/commissionSalary.json";
import en_agentSale from "./locales/en/agentSale.json";
import en_salary from "./locales/en/salary.json";
import en_supplier from "./locales/en/supplier.json";
import en_document from "./locales/en/document.json";
import en_reports from "./locales/en/reports.json";
import en_settings from "./locales/en/settings.json";
import en_rating from "./locales/en/rating.json";
import en_article from "./locales/en/article.json";
import en_documentDraft from "./locales/en/documentDraft.json";
import en_profileRoutine from "./locales/en/profileRoutine.json";
import en_accounting from "./locales/en/accounting.json";
import en_customer from "./locales/en/customer.json";
import en_todos from "./locales/en/todos.json";
import en_taskModule from "./locales/en/taskModule.json";
import en_permission from "./locales/en/permission.json";
import en_cashReconciliation from "./locales/en/cashReconciliation.json";
import en_revenueReporting from "./locales/en/revenueReporting.json";
import en_integrations from "./locales/en/integrations.json";
import en_search from "./locales/en/search.json";
import en_cashReconciliations from "./locales/en/cashReconciliation.json";
import en_businessUnits from "./locales/en/businessUnit.json";
import en_payments from "./locales/en/payments.json";
import en_timeReporting from "./locales/en/timeReporting.json";
import en_genericComments from "./locales/en/genericComments.json";
import en_allowance from "./locales/en/allowance.json";
import en_qualifiedShareDividends from "./locales/en/qualifiedShareDividends.json";
import en_agreement from "./locales/en/agreement.json";
import en_timeReportingProject from "./locales/en/timeReportingProject.json";
import en_quotation from "./locales/en/quotation.json";
import en_supplementaryMaterial from "./locales/en/supplementaryMaterial.json";
import en_annualAccount from "./locales/en/annualAccount.json";
import en_filter from "./locales/en/filter.json";
import en_eula from "./locales/en/eula.json";
import en_advisor from "./locales/en/advisor.json";
import en_holdingRegister from "./locales/en/holdingRegister.json";
import en_voucher from "./locales/en/voucher.json";
import en_boardMember from "./locales/en/boardMember.json";
import en_shareRegister from "./locales/en/shareRegister.json";
import en_about from "./locales/en/about.json";
import en_revisor from "./locales/en/revisor.json";
import en_automationRule from "./locales/en/automationRule.json";
import en_benefit from "./locales/en/benefit.json";
import en_externalCompanyHoldings from "./locales/en/externalCompanyHoldings.json";
import en_mobileAppPromotion from "./locales/en/mobileAppPromotion.json";
import en_monthlyReport from "./locales/en/monthlyReport.json";
import en_onboarding from "./locales/en/onboarding.json";
import en_costForwarding from "./locales/en/costForwarding.json";
import en_offboarding from "./locales/en/offboarding.json";
import sv_common from "./locales/sv/common.json";
import sv_incomingInvoice from "./locales/sv/incomingInvoice.json";
import sv_missingDocument from "./locales/sv/missingDocument.json";
import sv_login from "./locales/sv/login.json";
import sv_receipt from "./locales/sv/receipt.json";
import sv_validations from "./locales/sv/validations.json";
import sv_errors from "./locales/sv/errors.json";
import sv_currency from "./locales/sv/currency.json";
import sv_invoice from "./locales/sv/invoice.json";
import sv_supportIssue from "./locales/sv/supportIssue.json";
import sv_survey from "./locales/sv/survey.json";
import sv_salaryDeviation from "./locales/sv/salaryDeviation.json";
import sv_country from "./locales/sv/country.json";
import sv_language from "./locales/sv/language.json";
import sv_company from "./locales/sv/company.json";
import sv_commissionSalary from "./locales/sv/commissionSalary.json";
import sv_agentSale from "./locales/sv/agentSale.json";
import sv_salary from "./locales/sv/salary.json";
import sv_supplier from "./locales/sv/supplier.json";
import sv_document from "./locales/sv/document.json";
import sv_reports from "./locales/sv/reports.json";
import sv_settings from "./locales/sv/settings.json";
import sv_rating from "./locales/sv/rating.json";
import sv_article from "./locales/sv/article.json";
import sv_documentDraft from "./locales/sv/documentDraft.json";
import sv_profileRoutine from "./locales/sv/profileRoutine.json";
import sv_accounting from "./locales/sv/accounting.json";
import sv_customer from "./locales/sv/customer.json";
import sv_todos from "./locales/sv/todos.json";
import sv_taskModule from "./locales/sv/taskModule.json";
import sv_permission from "./locales/sv/permission.json";
import sv_cashReconciliation from "./locales/sv/cashReconciliation.json";
import sv_revenueReporting from "./locales/sv/revenueReporting.json";
import sv_integrations from "./locales/sv/integrations.json";
import sv_search from "./locales/sv/search.json";
import sv_cashReconciliations from "./locales/sv/cashReconciliation.json";
import sv_businessUnits from "./locales/sv/businessUnit.json";
import sv_payments from "./locales/sv/payments.json";
import sv_timeReporting from "./locales/sv/timeReporting.json";
import sv_genericComments from "./locales/sv/genericComments.json";
import sv_allowance from "./locales/sv/allowance.json";
import sv_qualifiedShareDividends from "./locales/sv/qualifiedShareDividends.json";
import sv_agreement from "./locales/sv/agreement.json";
import sv_timeReportingProject from "./locales/sv/timeReportingProject.json";
import sv_quotation from "./locales/sv/quotation.json";
import sv_supplementaryMaterial from "./locales/sv/supplementaryMaterial.json";
import sv_annualAccount from "./locales/sv/annualAccount.json";
import sv_filter from "./locales/sv/filter.json";
import sv_eula from "./locales/sv/eula.json";
import sv_advisor from "./locales/sv/advisor.json";
import sv_holdingRegister from "./locales/sv/holdingRegister.json";
import sv_voucher from "./locales/sv/voucher.json";
import sv_boardMember from "./locales/sv/boardMember.json";
import sv_shareRegister from "./locales/sv/shareRegister.json";
import sv_about from "./locales/sv/about.json";
import sv_revisor from "./locales/sv/revisor.json";
import sv_automationRule from "./locales/sv/automationRule.json";
import sv_benefit from "./locales/sv/benefit.json";
import sv_externalCompanyHoldings from "./locales/sv/externalCompanyHoldings.json";
import sv_mobileAppPromotion from "./locales/sv/mobileAppPromotion.json";
import sv_monthlyReport from "./locales/sv/monthlyReport.json";
import sv_onboarding from "./locales/sv/onboarding.json";
import sv_costForwarding from "./locales/sv/costForwarding.json";
import sv_offboarding from "./locales/sv/offboarding.json";

const Translations = {
  en: {
    ...en_common,
    ...en_incomingInvoice,
    ...en_missingDocument,
    ...en_login,
    ...en_receipt,
    ...en_validations,
    ...en_errors,
    ...en_currency,
    ...en_invoice,
    ...en_supportIssue,
    ...en_survey,
    ...en_salaryDeviation,
    ...en_country,
    ...en_language,
    ...en_company,
    ...en_commissionSalary,
    ...en_agentSale,
    ...en_salary,
    ...en_supplier,
    ...en_document,
    ...en_reports,
    ...en_settings,
    ...en_rating,
    ...en_article,
    ...en_documentDraft,
    ...en_profileRoutine,
    ...en_accounting,
    ...en_customer,
    ...en_todos,
    ...en_taskModule,
    ...en_permission,
    ...en_cashReconciliation,
    ...en_revenueReporting,
    ...en_integrations,
    ...en_search,
    ...en_cashReconciliations,
    ...en_businessUnits,
    ...en_payments,
    ...en_timeReporting,
    ...en_genericComments,
    ...en_allowance,
    ...en_qualifiedShareDividends,
    ...en_agreement,
    ...en_timeReportingProject,
    ...en_quotation,
    ...en_supplementaryMaterial,
    ...en_annualAccount,
    ...en_filter,
    ...en_eula,
    ...en_advisor,
    ...en_holdingRegister,
    ...en_voucher,
    ...en_boardMember,
    ...en_shareRegister,
    ...en_about,
    ...en_revisor,
    ...en_automationRule,
    ...en_benefit,
    ...en_externalCompanyHoldings,
    ...en_mobileAppPromotion,
    ...en_monthlyReport,
    ...en_onboarding,
    ...en_costForwarding,
    ...en_offboarding,
  },
  sv: {
    ...sv_common,
    ...sv_incomingInvoice,
    ...sv_missingDocument,
    ...sv_login,
    ...sv_receipt,
    ...sv_validations,
    ...sv_errors,
    ...sv_currency,
    ...sv_invoice,
    ...sv_supportIssue,
    ...sv_survey,
    ...sv_salaryDeviation,
    ...sv_country,
    ...sv_language,
    ...sv_company,
    ...sv_commissionSalary,
    ...sv_agentSale,
    ...sv_salary,
    ...sv_supplier,
    ...sv_document,
    ...sv_reports,
    ...sv_settings,
    ...sv_rating,
    ...sv_article,
    ...sv_documentDraft,
    ...sv_profileRoutine,
    ...sv_accounting,
    ...sv_customer,
    ...sv_todos,
    ...sv_taskModule,
    ...sv_permission,
    ...sv_cashReconciliation,
    ...sv_revenueReporting,
    ...sv_integrations,
    ...sv_search,
    ...sv_cashReconciliations,
    ...sv_businessUnits,
    ...sv_payments,
    ...sv_timeReporting,
    ...sv_genericComments,
    ...sv_allowance,
    ...sv_qualifiedShareDividends,
    ...sv_agreement,
    ...sv_timeReportingProject,
    ...sv_quotation,
    ...sv_supplementaryMaterial,
    ...sv_annualAccount,
    ...sv_filter,
    ...sv_eula,
    ...sv_advisor,
    ...sv_holdingRegister,
    ...sv_voucher,
    ...sv_boardMember,
    ...sv_shareRegister,
    ...sv_about,
    ...sv_revisor,
    ...sv_automationRule,
    ...sv_benefit,
    ...sv_externalCompanyHoldings,
    ...sv_mobileAppPromotion,
    ...sv_monthlyReport,
    ...sv_onboarding,
    ...sv_costForwarding,
    ...sv_offboarding,
  },
};

export default Translations;
export { TranslationKeys };
